import { post } from "../index";

export const createFeatureRequest = (id, body) => {
  return post(`/permissions/request-access/request`, body);
};
  